export default {
  CREATE: `#graphql
  mutation createBonus($input: BonusCreateInput!) {
    createBonus(input: $input) {
      bonus
      phone
      type
      status
    }
  }`,

  GET_ALL: `#graphql
  query getBonuses($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getBonuses(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init: $init, final: $final) { 
      docs {
        brand
        bonus
        order
        phone
        type
        changeId
        reason
        originalValue
        promotionPercent
        usedValue
        remainingValue
        status
        used
        transactions {
          order
          valueUsed
          usedAt
          createdAt
        }
        products {
          product
          size
          quantity
          reason,
          value,
          image
        }
        observation
        version
        createdBy
        createdAt
        updatedBy
        updatedAt
        approvedBy
        approvedAt
        declinedBy
        declinedAt
        conveyorCustomer
        tracking
        packReceived
        packReceivedAt
        packReceivedBy
        packageCost
        notifications {
          returnApprovedWhatsappSent
          history {
            platform
            status
            error
            createdAt
          }
        }
      }
      totalDocs
      limit
      hasPrevPage
      hasNextPage
      page
      totalPages
      prevPage
      nextPage
      pagingCounter
    }            
  }`,

  UPDATE: `#graphql
  mutation updateBonus($bonus: String!, $bonusUpdate: BonusUpdateInput!) {
    updateBonus(bonus: $bonus, bonusUpdate: $bonusUpdate) {
      bonus
      observation
      conveyorCustomer
      tracking
      packageCost
    }            
  }`,

  APPROVE: `#graphql
  mutation approveBonus($bonus: String!) {
    approveBonus(bonus: $bonus)        
  }`,

  DISAPPROVE: `#graphql
  mutation disapproveBonus($bonus: String!) {
    disapproveBonus(bonus: $bonus)        
  }`,

  DECLINE: `#graphql
  mutation declineBonus($bonus: String!) {
    declineBonus(bonus: $bonus)        
  }`,

  RECEIVE_PACKAGE: `#graphql
  mutation receiveBonusPackage($bonus: String!) {
    receiveBonusPackage(bonus: $bonus)
  }`,

  UNRECEIVE_PACKAGE: `#graphql
  mutation unreceiveBonusPackage($bonus: String!) {
    unreceiveBonusPackage(bonus: $bonus)
  }`,

  SEND_NOTIFICATION: `#graphql
  mutation sendBonusNotification($bonus: String!) {
    sendBonusNotification(bonus: $bonus)
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/bonus.js